import "./Home.module.css";
import GlobalHeader from "@/reusable_sections/Header";
import InstitutionalMandate from "./sections/InstitutionalMandate";
import MarketBenchmarks from "./sections/MarketBenchmarks";
import CapitalEcosystem from "./sections/CapitalEcosystem";
import TheDynestateStandard from "./sections/TheDynestateStandard";
import MarketplaceInsights from "./sections/MarketplaceInsights";
import StrategicAccessInquiry from "./sections/StrategicAccessInquiry";
import InstitutionalFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <GlobalHeader />
      <InstitutionalMandate />
      <MarketBenchmarks />
      <CapitalEcosystem />
      <TheDynestateStandard />
      <MarketplaceInsights />
      <StrategicAccessInquiry />
      <InstitutionalFooter />
    </div>;
}